if ($('#press-release-search').length) {

    let searchContainer = $('#press-release-search'),
        resultsContainer = $('#press-release-search-results'),
        paginationContainer = $('#press-release-pagination-container'),
        paginationDisplay = $('.press-release-pagination-display'),
        categoryFilterItems = $('.press-release-filter-category'), // Define this correctly
        currentFilterTags = $('.press-release-current-filter-tags'),
        page = 1;

    // Results are already filtered server-side when a ?category=<slug> preselect is present
    // (the matching <li> is rendered with .is-checked). Just reveal the Clear button to match.
    if ($('.is-checked').length > 0) {
        $('.press-release-clear').removeClass('d-none');
    }

    $(document).on('click', '.press-release-page-link', function (e) {
        e.preventDefault();
        page = $(this).data('page');
        pressReleaseSearch();
    });

    $(document).on('click', '.press-release-page-prev', function (e) {
        e.preventDefault();
        if ($(this).hasClass('disabled')) return;
        page--;
        pressReleaseSearch();
    });

    $(document).on('click', '.press-release-page-next', function (e) {
        e.preventDefault();
        if ($(this).hasClass('disabled')) return;
        page++;
        pressReleaseSearch();
    });

    categoryFilterItems.on('click', function(e) {
        e.preventDefault();
        $(this).parent().toggleClass('is-checked');

        if ($('.is-checked').length > 0) {
            $('.press-release-clear').removeClass('d-none');
        } else {
            $('.press-release-clear').addClass('d-none');
        }
        pressReleaseSearch();
    });

    $(document).on('click', '.press-release-current-filter-tags button', function () {
        $('.press-release-filter-category-' + $(this).data('category')).parent().removeClass('is-checked');

        if ($('.is-checked').length > 0) {
            $('.press-release-clear').removeClass('d-none');
        } else {
            $('.press-release-clear').addClass('d-none');
        }
        pressReleaseSearch();
    });


    $(document).on('click', '.press-release-clear', function () {
        $('.press-release-filter-category').each(function() {
            $('.press-release-filter-category-' + $(this).data('category')).parent().removeClass('is-checked');
        });
        $('.press-release-clear').addClass('d-none');
        pressReleaseSearch();
    });

    function pressReleaseSearch() {
        let categoryFilters = [];

        $('.press-release-filter-category').each(function() {
            if ($(this).parent().hasClass('is-checked')) {
                categoryFilters.push($(this).data('category'));
            }
        });


        $.post("/wp-admin/admin-ajax.php", {
            'action': 'post_releases_search',
            'categories': categoryFilters,
            'page': page,
        }, function (response) {
            if (response.success) {
                resultsContainer.html(response.data.results);
                paginationContainer.html(response.data.pagination);
                paginationDisplay.html(response.data.pagination_display);
                currentFilterTags.html(response.data.current_filter_tags);
                page = 1;

                $('html, body').animate({
                    scrollTop: searchContainer.offset().top
                }, 500);
            } else {
                console.log("No success in AJAX response:", response);
            }
        }).fail(function(xhr, status, error) {
            console.error("Error in AJAX request:", error);
        });
    }
}